import { useEffect, useRef, useState } from "react";
import { FaBell, FaExclamationTriangle } from "react-icons/fa";
import { others } from "../../services/other.services";
import { useAuth } from "../../contexts/AuthContext";
import { NavLink } from "react-router-dom";

export const Alerts = () => {
  const [alerts, setAlerts] = useState([]);
  const [isStratificationOpen, setIsStratificationOpen] = useState(false);
  const stratificationWrapperRef = useRef(null);
  const { authToken, checkLicense } = useAuth();
  const isPenfast = checkLicense("penfast");
  const isStratification = checkLicense("stratification");

  useEffect(() => {
    if (!authToken || (!isPenfast && !isStratification)) return;

    const getAlerts = async () => {
      try {
        const response = await others.getAlerts();
        if (response.status === 200) {
          setAlerts(response.data);
        }
      } catch (error) {
        console.error("Failed to fetch alerts:", error);
      }
    };

    getAlerts();

    const interval = setInterval(() => {
      getAlerts();
    }, 30000);

    return () => clearInterval(interval);
  }, [authToken, isPenfast, isStratification]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        stratificationWrapperRef.current &&
        !stratificationWrapperRef.current.contains(e.target)
      ) {
        setIsStratificationOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  if (!authToken || (!isPenfast && !isStratification)) {
    return null;
  }

  const penfastAlert = alerts.find((a) => a.name === "penfasts");
  const stratificationAlert = alerts.find((a) => a.name === "stratifications");
  const affectedPatients =
    stratificationAlert?.details?.affected_patients || [];
  const navigablePatients = affectedPatients.filter(
    (patient) => patient.clinic_id != null,
  );

  return (
    <div style={{ display: "inline-flex", alignItems: "center", gap: "18px" }}>
      {isPenfast && (
        <div style={{ position: "relative", display: "inline-block" }}>
          <NavLink to="/pen-fast/present/hospitalization">
            <FaBell
              size={18}
              style={
                penfastAlert?.state === "red_warning"
                  ? { color: "red" }
                  : { color: "#ffffff" }
              }
            />
          </NavLink>
          {penfastAlert?.details?.not_evaluated_penfast_count > 0 && (
            <span
              style={{
                position: "absolute",
                top: "12px",
                right: "20px",
                color: "white",
                fontSize: "10px",
              }}
            >
              {penfastAlert?.details?.not_evaluated_penfast_count}
            </span>
          )}
        </div>
      )}

      {isStratification && (
        <div
          className="stratification-alert"
          ref={stratificationWrapperRef}
          style={{ position: "relative", display: "inline-block" }}
        >
          <span
            role="button"
            tabIndex={0}
            onClick={() => setIsStratificationOpen((open) => !open)}
            style={{ cursor: "pointer" }}
          >
            <FaExclamationTriangle
              size={18}
              style={
                stratificationAlert?.state === "red_warning"
                  ? { color: "red" }
                  : { color: "#ffffff" }
              }
            />
            {navigablePatients.length > 0 && (
              <span
                style={{
                  position: "absolute",
                  top: "12px",
                  right: "-8px",
                  color: "white",
                  fontSize: "10px",
                }}
              >
                {navigablePatients.length}
              </span>
            )}
          </span>

          {isStratificationOpen && (
            <div className="stratification-alert-menu">
              <div>
                {navigablePatients.length === 0 ? (
                  <div className="stratification-alert-empty">
                    Žádní rizikoví pacienti
                  </div>
                ) : (
                  <table>
                    <tbody>
                      {navigablePatients.map((patient) => (
                        <tr key={`${patient.patient_id}-${patient.care_id}`}>
                          <td>
                            <NavLink
                              to={`/patients-hospital/${patient.clinic_id}/present/hospitalization`}
                              onClick={() => setIsStratificationOpen(false)}
                            >
                              {patient.clinic_name}
                            </NavLink>
                          </td>
                          <td>
                            <NavLink
                              to={`/patient-profile/${patient.patient_id}/care/${patient.care_id}/pharmacological-plan`}
                              onClick={() => setIsStratificationOpen(false)}
                            >
                              {patient.patient_name}
                            </NavLink>
                          </td>
                          <td>Skóre rizika: {patient.total_risk_score}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
